import React from "react";
import '../../sass/components/flexibleModules/_components.freeFormHtml.scss';

const FreeFormHtml = ({ data }) => {
    return (
        <div className={`cp-freeFormHtml ${data.overrideClass ? data.overrideClass : ""}`} style={{backgroundColor: `${data.backgroundColor ? data.backgroundColor : ""}`}}>
            <div className="cp-freeFormHtml__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.freeFormHtmlHeader &&
                    <h2>{data.freeFormHtmlHeader}</h2>
                }
                {data.freeFormHtmlBlock &&
                    <div dangerouslySetInnerHTML={{__html: data.freeFormHtmlBlock}} />
                }
            </div>
        </div>
    );
}

export default FreeFormHtml;